import { useTranslation } from "react-i18next";
import { Badge } from "@/atoms/badge";
import { Button } from "@/atoms/button";

/**
 * The old checkout's cancel return.
 *
 * Nothing went wrong and nothing was lost, so the page says exactly that and offers the way
 * back. The neutral badge and not a danger one: leaving a payment page is a choice, not a
 * failure, and red here would tell someone off for changing their mind.
 */

export function Checkoutv1CancelPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-surface-paperSoft px-gk-4 py-gk-8 flex min-h-screen flex-col items-center justify-center">
      <div className="ds-reveal sm:bg-surface-paper ds-hairline sm:rounded-card sm:p-gk-6 gap-gk-6 flex w-full max-w-[520px] flex-col sm:border">
        <div className="gap-gk-4 flex flex-col items-start">
          <Badge tone="neutral">{t("gymkeePay.common.statusNotPaid")}</Badge>
          <h1 className="text-[32px] leading-[1.15] font-semibold text-[var(--gk-text-primary)]">
            {t("gymkeePay.receipt.cancelHeadline")}
          </h1>
          <p className="text-[15px] leading-[1.55] text-[var(--gk-text-secondary)]">
            {t("gymkeePay.receipt.cancelLine")}
          </p>
        </div>
        <Button
          variant="secondary"
          onClick={() => window.history.back()}
          className="ds-pay-hand self-start"
        >
          {t("gymkeePay.receipt.backToPayment")}
        </Button>
      </div>
    </div>
  );
}
